import { motion } from "framer-motion";
import { WhatsappLogo } from "@phosphor-icons/react";

const WA_URL =
  "https://wa.me/995568055574?text=" +
  encodeURIComponent("Hi WOFERS GLOBAL, I'd like to explore a B2B partnership.");

export default function WhatsAppButton() {
  return (
    <motion.a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat with WOFERS GLOBAL on WhatsApp"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.5, delay: 2.2, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-[80] flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_32px_rgba(37,211,102,0.35)] transition-shadow duration-300 hover:shadow-[0_8px_40px_rgba(37,211,102,0.55)] md:bottom-8 md:right-8"
    >
      <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366]/30 [animation-duration:2.5s]" aria-hidden="true" />
      <WhatsappLogo size={28} weight="fill" className="relative" />
    </motion.a>
  );
}
